import Link from "@components/Link/Link";
import { ArrowRight as ArrowIcon } from "lucide-react";

import { useMenuStore } from "@/stores/menuStore";

import type { NavigationLink } from "../types";

export default function SimpleDropdown({
  link,
  locale,
}: {
  link: NavigationLink;
  locale?: string;
}) {
  const { clearActiveWithDelay } = useMenuStore();

  return (
    <ul className="border-gray-150 absolute top-full left-2 z-10 flex min-w-32 flex-col gap-2.5 border bg-white p-4 whitespace-nowrap">
      {link?.children?.map(
        (item) =>
          item && (
            <li key={item.slug}>
              <Link
                onClick={() => clearActiveWithDelay()}
                locale={locale}
                className="group flex items-center hover:underline"
                href={item?.slug}
                prefetch={false}
                customPrefetch="onMouseEnter"
              >
                {item.title}
                <ArrowIcon
                  strokeWidth={1}
                  className="size-4.5 opacity-0 transition-[opacity,transform] group-hover:translate-x-1 group-hover:opacity-100"
                />
              </Link>
            </li>
          ),
      )}
    </ul>
  );
}
